<!-- Page shown to verify email -->
<template>
  <v-container fluid fill-height class="remove">
    <v-snackbar top v-model="snackbar" color="success" :timeout="4000">Email Sent!</v-snackbar>
    <v-dialog v-model="failedDialog" max-width="400" class="remove">
      <v-card>
        <v-card-title class="headline warning white--text" primary-title>
          <v-icon color="white">warning</v-icon>
        </v-card-title>
        <p class="text-center">Failed, log in and visit this link again.</p>

        <v-row align="center" justify="center">
          <v-col cols="4" md="3" align="center">
            <v-btn class="ml-5 my-5 secondary darken-1 white--text" @click="failedDialog=false">Okay</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-container fluid fill-height v-if="doneLoading">
      <v-row align="center" justify="center" v-if="failed">
        <v-col cols="12" align="center" justify="center">
          <v-card flat align="center" justify="center">
            <p class="text-center title">Link is invalid or has expired.</p>
            <!-- <v-btn
              text
              class="secondary white--text"
              @click="sendNewEmail"
              :loading="loading"
            >Request a new link</v-btn>
            <p ref="error" class="error--text mt-2"></p> -->
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" align="center" justify="center" class="mr-1 ml-1" v-if="success">
          <v-card flat>
            <h3 class="text-center success--text">Success</h3>
            <p class="text-center">Your email {{email}} was verified</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { auth } from "@/firebase";
export default {
  props: {
    actionCode: String,
  },
  data() {
    return {
      doneLoading: false,
      success: false,
      failed: false,
      requestedLinkSuccess: false, //toggled to true if user requests for a new confirmation email
      snackbar: false,
      loading: false,
      failedDialog: false,
      error: "",
    };
  },
  methods: {
    sendNewEmail() {
      this.loading = true;
      let user = auth.currentUser;
      if (user == undefined || user == null) {
        this.failedDialog = true;
        this.loading = false;
      } else {
        user
          .sendEmailVerification()
          .then(() => {
            this.loading = false;
            this.snackbar = true;
          })
          .catch((error) => {
            this.loading = false;
            this.$refs.error.innerHTML = error.toString();
          });
      }
    },
  },
  created() {
    console.log('verify email page')
    auth
      .applyActionCode(this.actionCode)
      .then(() => {
        console.log('success verify')
        this.success = true;
        this.doneLoading = true;
      })
      .catch(() => {
        console.log('failed verify')
        this.failed = true;
        this.doneLoading = true;
      });
  },
};
</script>


<style scoped>
@media only screen and (min-width: 768px) {
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 30%;
  }
  .remove {
    overflow-x: hidden;
  }
}
</style>
